@if (_isDateFilter()) {
  @if (_dateValue(); as date) {
    <myre-arrows-date-picker
      class="filter framed"
      [date]="date"
      [type]="_dateFilter().step ?? 'date'"
      [nextTooltipLabel]="_dateFilter().nextTooltipLabel"
      [previousTooltipLabel]="_dateFilter().previousTooltipLabel"
      (onDateChange)="_onAlwaysEditableValueChange($event)"
    />
  }
} @else if (_isSwitchFilter()) {
  <myre-switch
    class="filter framed"
    [label]="_switchFilter().label"
    [onLabel]="_switchFilter().onLabel"
    [offLabel]="_switchFilter().offLabel"
    [readonly]="_switchFilter().readonly ?? false"
    [withBackground]="false"
    [fitHeight]="true"
    [ngModel]="_switchValue()"
    (ngModelChange)="_onAlwaysEditableValueChange($event)"
  />
} @else if (_editMode()) {
  @if (_isPeriodPickerFilter()) {
    <myui-period-picker
      #periodPicker
      class="filter"
      [types]="_periodPickerFilter()['types']"
      [options]="_periodPickerFilter()['options']"
      [placeholder]="_periodPickerFilter()['label']"
      [(value)]="_periodPickerFilterSelectedValue"
      (closed)="_switchEditMode()"
      (changed)="_onValueChange($event.value)"
    />
  } @else {
    <myre-dropdown
      #dropdown
      [list]="filteringOptions()"
      [type]="_basicFilter().type"
      [placeholder]="_basicFilter().label"
      [ngModel]="_selectedOptions()"
      [loading]="_isLoadingOptions()"
      [disableSearch]="true"
      labelStyleClass="m-max-height:10 m-overflow-y:hidden"
      [asideOpen]="_activeGroupIndex() !== null"
      (ngModelChange)="_setSelectedOptions($event)"
      (onFocus)="_onOpen()"
      (onBlur)="_switchEditMode()"
      class="filter"
    >
      @if (_basicFilter().searchable || _groups().length) {
        <ng-template dropdownTemplate="header">
          @if (_basicFilter().searchable) {
            <div class="m-padding:4 m-border-b">
              <myre-textbox
                type="search"
                [placeholder]="_wordings._ui.search()"
                [ngModel]="searchFilter()"
                (ngModelChange)="searchFilter.set($event)"
              />
            </div>
          }

          @if (_groups().length) {
            @for (group of _groups(); track group.label; let i = $index) {
              <div
                class="m-flex m-flex-items:center m-flex-justify:between m-padding-v:2 m-padding-h:4 m-cursor:pointer m-text-color:neutral m-hover:bg-color:primary-pale"
                role="button"
                tabindex="0"
                [class]="{ 'm-bg-color:grey-100': _activeGroupIndex() === i }"
                (click)="_toggleGroup(i)"
              >
                <span>{{ group.label }}</span>
                <i class="myre-icon-arrow_next group-chevron"></i>
              </div>
            }
          }
        </ng-template>
      }

      @if (_groups().length) {
        <ng-template dropdownTemplate="aside">
          @if (_activeGroup(); as group) {
            @for (option of group.options; track option.value) {
              <div
                class="m-flex m-flex-items:center m-gap:2 m-padding-v:2 m-padding-h:4 m-cursor:pointer m-text-color:neutral m-hover:bg-color:primary-pale"
                (click)="
                  _toggleActiveGroupOption(
                    option.value,
                    !_isActiveGroupOptionChecked(option.value)
                  )
                "
              >
                <myre-checkbox
                  [ngModel]="_isActiveGroupOptionChecked(option.value)"
                  (ngModelChange)="
                    _toggleActiveGroupOption(option.value, $event)
                  "
                />
                {{ option.label }}
              </div>
            }
          }
        </ng-template>
      }
    </myre-dropdown>
  }
} @else {
  <div
    class="tag"
    role="button"
    tabindex="0"
    aria-label="edit selection"
    (click)="_switchEditMode()"
  >
    @if (_isResolving()) {
      <myre-dots-loader />
    } @else if (_basicFilter().options !== undefined) {
      {{ _selectedOptions() | tagLabel: _displayFilter() }}
      <i
        role="button"
        tabindex="0"
        aria-label="delete selection"
        class="myre-icon-close"
        (click)="_setSelectedOptions(null)"
      ></i>
    } @else {
      <myre-dots-loader />
    }
  </div>
}
